import state from "@/store/modules/page";
import actions from "@/store/modules/page/actions";
import mutations from "@/store/modules/page/mutations";

export default {
    state,
    actions,
    mutations,
}